import { createSlice } from '@reduxjs/toolkit'

const orderPollingSlice = createSlice({
  name: 'orderPolling',
  initialState: {
    shouldPoll: false,
    lastOrderPlacedAt: null,
    pollingDuration: 30000 // 30 seconds in milliseconds
  },
  reducers: {
    startPolling: (state) => {
      state.shouldPoll = true
      state.lastOrderPlacedAt = Date.now()
    },
    stopPolling: (state) => {
      state.shouldPoll = false
      state.lastOrderPlacedAt = null
    },
    setPollingDuration: (state, action) => {
      state.pollingDuration = action.payload
    }
  }
})

export const { startPolling, stopPolling, setPollingDuration } = orderPollingSlice.actions

export default orderPollingSlice.reducer
